import ROUTES from './paths'

export const studentsAndFacultyTabs = [
  { label: 'Faculty and Staff', to: ROUTES.FACULTY_AND_STAFF },
  { label: 'Students', to: ROUTES.STUDENTS }
]
